import VueRouter from 'vue-router'
import { store } from './store/store';
import MainComponent from './layouts/Main.vue';
import AuthLayout from './layouts/Auth.vue';
import Vue from 'vue';

Vue.use(VueRouter);

const isRequiredAuth = true;
const isRequiredPermission = true;
const noBreadCrumb = false;

const routes = [
  {
    path: '/',
    name: 'default',
    component: () =>
      import(/* webpackChunkName: "DashboardView" */ "./views/Dashboard.vue"),
    meta: {
      requiresAuth: isRequiredAuth,
      layout: MainComponent,
      redirectIfCanAccessUrl: '/Dashboard'
    }
  },
  {
    path: '/Dashboard',
    name: 'dashboard',
    component: () =>
      import(/* webpackChunkName: "DashboardView" */ "./views/Dashboard.vue"),
    meta: {
      requiresAuth: isRequiredAuth,
      layout: MainComponent,
      requiresPermission: isRequiredPermission
    }
  },
  {
    path: '/RevenueManagementByDate/:InititalStartDate',
    name: 'revenueManagementByDate',
    props: true,
    component: () =>
      import(/* webpackChunkName: "RevenueManagementByDateView" */ "./views/RevenueManagement.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
 
  {
    path: '/CityLedger',
    name: 'cityledger',
    component: () =>
      import(/* webpackChunkName: "CityledgerView" */ "./views/ChannelCollectPayment/BookingTypeViewOutstanding.vue"),
      meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PaymentForBookingType/:BookingType/:BookingTypeValue/:BookingTypeDesc/:BookingTypeValueDesc',
    name: 'channelpayment',
    props: true,
    component: () =>
      import(/* webpackChunkName: "PaymentForBookingTypeView" */ "./views/ChannelCollectPayment/PaymentForBookingType.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/OnlineChannel',
    name: 'onlineChannel',
    props: true,
    component: () =>
      import(/* webpackChunkName: "OnlineChannelIndexView" */ "./views/bookingChannels/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OnlineChannelSettings/:BookingChannelId',
    name: 'onlineChannelSettings',
    props: true,
    component: () =>
      import(/* webpackChunkName: "OnlineChannelSettingsView" */ "./views/bookingChannels/BookingChannelSettings.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/RevenueManagement',
    name: 'revenueManagement',

    component: () =>
      import(/* webpackChunkName: "RevenueManagementView" */ "./views/RevenueManagement.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/DocumentTemplate',
    name: 'documentTemplate',

    component: () =>
      import(/* webpackChunkName: "DocumentTemplateView" */ "./views/document/DocumentTemplate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailSender',
    name: 'emailSender',

    component: () =>
      import(/* webpackChunkName: "EmailSettingView" */ "./views/email/EmailSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/EmailTemplate',
    name: 'emailTemplate',

    component: () =>
      import(/* webpackChunkName: "EmailTemplateView" */ "./views/email/EmailTemplate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/HousekeepingRoster',
    name: 'housekeepingRoster',

    component: () =>
      import(/* webpackChunkName: "HousekeepingRoster" */ "./views/ischeduler/HousekeepingRoster.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RevenueManagementAudit',
    name: 'revenueManagementAudit',
    component: () =>
      import(/* webpackChunkName: "RevenueManagementAuditView" */ "./views/RevenueManagementAudit.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/bookingDetailReport',
    name: 'bookingDetailReport',
    component: () =>
      import(/* webpackChunkName: "BookingDetailReportView" */ "./views/reports/operation/BookingDetailReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/bookingDetailReportHourly',
    name: 'bookingDetailReportHourly',
    component: () =>
      import(/* webpackChunkName: "BookingDetailReportView" */ "./views/reports/operation/BookingDetailReportHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/netRevenueReport',
    name: 'netRevenueReport',
    component: () =>
      import(/* webpackChunkName: "NetRevenueReportView" */ "./views/reports/operation/NetRevenueReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/guestDetailReport',
    name: 'guestDetailReport',
    component: () =>
      import(/* webpackChunkName: "GuestDetailReportView" */ "./views/reports/operation/GuestDetailReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/BookingChargeSalesReport',
    name: 'BookingChargeSalesReport',
    component: () =>
      import(/* webpackChunkName: "BookingChargeSalesReportView" */ "./views/reports/accounting/BookingChargeSalesReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/salesReport',
    name: 'salesReport',
    component: () =>
      import(/* webpackChunkName: "SalesReportView" */ "./views/reports/accounting/SalesReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },


  {
    path: '/RoomTypeChannelAvailability',
    name: 'roomTypeChannelAvailability',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/RoomTypeChannelLimit.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  //{
  //  path: '/RoomTypeChannelLimit',
  //  name: 'roomTypeChannelLimit',
  //  component: () =>
  //    import(/* webpackChunkName: "RoomTypeChannelLimitView" */ "./views/RoomTypeChannelLimit.vue"),
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  //},

  {
    path: '/RoomShutDown',
    name: 'roomShutDown',
    component: () =>
      import(/* webpackChunkName: "RevenueManagementAuditView" */ "./views/RoomShutDown.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "LoginView" */ "./views/Login.vue"),
    meta: { requiresAuth: false, requiresGuest: true, layout: AuthLayout }
  },
  {
    path: '/Maintenance',
    name: 'maintenance',
    component: () =>
      import(/* webpackChunkName: "MaintenanceView" */ "./views/Maintenance.vue"),
    meta: { requiresAuth: false, requiresGuest: true, layout: AuthLayout }
  },
  {
    path: '/ForgotPassword',
    name: 'forgotPassword',
    component: () =>
      import(/* webpackChunkName: "ForgotPasswordView" */ "./views/auth/ForgotPassword.vue"),
    meta: { requiresAuth: false, requiresGuest: true, layout: AuthLayout }
  },
  {
    path: '/ChangePassword',
    name: 'changePassword',
    component: () =>
      import(/* webpackChunkName: "ChangePasswordView" */ "./views/auth/ChangePassword.vue"),
    props: route => ({ token: route.query.token, email: route.query.email }),
    meta: { requiresAuth: false, requiresGuest: true, layout: AuthLayout }
  },
  {
    path: '/NewReservation/:InititalStartDate',
    name: 'newReservation',
    component: () =>
      import(/* webpackChunkName: "NewReservationView" */ "./components/reservation/NewReservation.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/NewRoom/:BookingId/:BookingType/:CorporateId/:ChannelId',
    name: 'newRoom',
    component: () =>
      import(/* webpackChunkName: "NewRoomView" */ "./views/bookingEngine/reservation/CreateReservation.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ReservationDetails/:BookingId',
    name: 'reservationDetails',
    component: () =>
      import(/* webpackChunkName: "ReservationDetailsView" */ "./components/reservation/ReservationDetails.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PropertyLog',
    name: 'propertyLog',
    component: () =>
      import(/* webpackChunkName: "PropertyLogView" */ "./views/property/PropertyLog.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomTypeSetting',
    name: 'roomTypeSetting',
    component: () =>
      import(/* webpackChunkName: "RoomTypeSettingView" */ "./views/roomType/RoomTypeSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomTypeImage/:RoomTypeId/Upload',
    name: 'roomTypeImage',
    props: true,
    component: () =>
      import(/* webpackChunkName: "RoomTypeImageSettingView" */ "./views/roomType/RoomTypeImageSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/CompanySetting',
    name: 'companySetting',
    component: () =>
      import(/* webpackChunkName: "CompanySettingView" */ "./views/company/CompanySetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/Building',
    name: 'building',
    component: () =>
      import(/* webpackChunkName: "BuildingSettingView" */ "./views/building/BuildingSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/FloorLevel/:BuildingId/Upload',
    name: 'floorLevel',
    props: true,
    component: () =>
      import(/* webpackChunkName: "RoomTypeImageSettingView" */ "./views/building/FloorLevelSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/Property',
    name: 'property',
    component: () =>
      import(/* webpackChunkName: "PropertySettingView" */ "./views/property/PropertySetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/Room',
    name: 'room',
    component: () =>
      import(/* webpackChunkName: "RoomSettingView" */ "./views/room/RoomSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/Bed/:RoomId/Upload',
    name: 'bed',
    props: true,
    component: () =>
      import(/* webpackChunkName: "BedSettingView" */ "./views/room/BedSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  // Flex Inventory link admin (RoomShutdown auto-blocking via InventoryLink).
  {
    path: '/InventoryLink',
    name: 'inventoryLink',
    component: () =>
      import(/* webpackChunkName: "InventoryLinkView" */ "./views/inventoryLink/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/Corporate',
    name: 'corporate',
    component: () =>
      import(/* webpackChunkName: "Corporate" */ "./views/Corporate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/Corporate/:cid/CorporateRoomTypePromotions',
    name: 'corporateRTP',
    component: () => import(/* webpackChunkName: "CorpRTP" */ "./views/CorpRatePlanTypePromotion.vue"),
    props: route => ({ cid: parseInt(route.params.cid) }),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RosterSetting',
    name: 'roster',
    component: () =>
      import(/* webpackChunkName: "Roster" */ "./views/ischeduler/RosterSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },
  {
    path: '/Users',
    name: 'users',
    component: () =>
      import(/* webpackChunkName: "Users" */ "./views/user/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/SyncMissingBooking',
    name: 'syncMissingBooking',
    component: () =>
      import(/* webpackChunkName: "SyncMissingBookingViews" */ "./views/onlineBookings/SyncMissingBooking.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/KioskUsers',
    name: 'kioskUsers',
    component: () =>
      import(/* webpackChunkName: "KioskUsers" */ "./views/user/KioskUser.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/UserGroups',
    name: 'userGroups',
    component: () =>
      import(/* webpackChunkName: "UserGroups" */ "./views/userGroup/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PageNotFound',
    name: 'pageNotFound',
    component: () =>
      import(/* webpackChunkName: "PageNotFound" */ "./views/404.vue"),
    meta: { requiresAuth: true, layout: '' }
  },
  {
    path: '/HousekeepingPriority',
    name: '/housekeepingPriority',
    component: () =>
      import(/* webpackChunkName: "Roster" */ "./views/ischeduler/HousekeepingPriority.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },
  {
    path: '/Roles',
    name: 'housekeepers',
    component: () =>
      import(/* webpackChunkName: "HousekeeperIndex" */ "./views/ischeduler/Housekeeper.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/TaskDuration',
    name: 'roomTypeCleaningDuration',
    component: () =>
      import(/* webpackChunkName: "RoomTypeCleaningDurationIndex" */ "./views/ischeduler/RoomTypeCleaningDuration.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CommonArea',
    name: 'commonArea',
    component: () =>
      import(/* webpackChunkName: "CommonAreaIndex" */ "./views/ischeduler/commonArea/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/AbsenceFromWork',
    name: 'AbsenceFromWork',
    component: () =>
      import(/* webpackChunkName: "AbsenceFromWorkIndex" */ "./views/ischeduler/leaveOfAbsence/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/LiveCleaningSchedule',
    name: 'liveCleaningSchedule',
    component: () =>
      import(/* webpackChunkName: "LiveCleaningScheduleIndex" */ "./views/ischeduler/LiveCleaningSchedule.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ResourceAllocationAndForecast',
    name: 'resourceAllocationAndForecast',
    component: () =>
      import(/* webpackChunkName: "ResourceAllocationAndForecastIndex" */ "./views/ischeduler/ResourceAllocationAndForecast.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtherSettings',
    name: 'otherSettings',
    component: () =>
      import(/* webpackChunkName: "OtherSettings" */ "./views/ischeduler/OtherSettings.vue"),
    props: route => ({ category: route.query.category }),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  //{
  //  path: '/OtherSettings?category=1',
  //  name: 'mainSettings',
  //  component: () =>
  //    import(/* webpackChunkName: "OtherSettings" */ "./views/ischeduler/OtherSettings.vue"),
  //  props: route => ({ category: route.query.category }),
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  //},
  {
    path: '/KeySystem',
    name: 'keySystem',
    component: () =>
      import(/* webpackChunkName: "KeySystem" */ "./views/KeySystem/KeySystem.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/TaskPriority',
    name: 'taskPriority',
    component: () =>
      import(/* webpackChunkName: "TaskPriority" */ "./views/ischeduler/TaskPriority.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyYearandMonth',
    name: 'OverallPerformancebyYearandMonth',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyYearandMonthView" */ "./views/reports/revenue/OverallPerformancebyYearandMonth.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyYearandMonthHourly',
    name: 'OverallPerformancebyYearandMonthHourly',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyYearandMonthView" */ "./views/reports/revenue/OverallPerformancebyYearandMonthHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyRoomType',
    name: 'OverallPerformancebyRoomType',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyRoomTypeView" */ "./views/reports/revenue/OverallPerformancebyRoomType.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyRoomTypeHourly',
    name: 'OverallPerformancebyRoomTypeHourly',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyRoomTypeView" */ "./views/reports/revenue/OverallPerformancebyRoomTypeHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ForwardBookingByYearMonth',
    name: 'ForwardBookingByYearMonth',
    component: () =>
      import(/* webpackChunkName: "ForwardBookingByYearMonthView" */ "./views/reports/revenue/ForwardBookingByYearMonth.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ForwardBookingByYearMonthHourly',
    name: 'ForwardBookingByYearMonthHourly',
    component: () =>
      import(/* webpackChunkName: "ForwardBookingByYearMonthView" */ "./views/reports/revenue/ForwardBookingByYearMonthHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/MonthlyRevenueReport',
    name: 'MonthlyRevenueReport',
    component: () =>
      import(/* webpackChunkName: "MonthlyRevenueReportView" */ "./views/reports/revenue/MonthlyRevenueReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/ForwardBookingByRoomtype',
    name: 'ForwardBookingByRoomtype',
    component: () =>
      import(/* webpackChunkName: "ForwardBookingByRoomtypeView" */ "./views/reports/revenue/ForwardBookingByRoomtype.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ForwardBookingByRoomtypeHourly',
    name: 'ForwardBookingByRoomtypeHourly',
    component: () =>
      import(/* webpackChunkName: "ForwardBookingByRoomtypeView" */ "./views/reports/revenue/ForwardBookingByRoomtypeHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ForwardBookingBySpecificDate',
    name: 'ForwardBookingBySpecificDate',
    component: () =>
      import(/* webpackChunkName: "ForwardBookingBySpecificDateView" */ "./views/reports/revenue/ForwardBookingBySpecificDate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/AverageandModeofLeadTimeandRate',
    name: 'AverageandModeofLeadTimeandRate',
    component: () =>
      import(/* webpackChunkName: "AverageandModeofLeadTimeandRateView" */ "./views/reports/revenue/AverageandModeofLeadTimeandRate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/AverageandModeofLeadTimeandRateHourly',
    name: 'AverageandModeofLeadTimeandRateHourly',
    component: () =>
      import(/* webpackChunkName: "AverageandModeofLeadTimeandRateView" */ "./views/reports/revenue/AverageandModeofLeadTimeandRateHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/InvoiceReport',
    name: 'invoiceReport',
    component: () =>
      import(/* webpackChunkName: "InvoiceReport" */ "./views/reports/operation/InvoiceReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CommissionReport',
    name: 'commissionReport',
    component: () =>
      import(/* webpackChunkName: "CommissionReport" */ "./views/reports/accounting/CommissionReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CollectionReport',
    name: 'collectionReport',
    component: () =>
      import(/* webpackChunkName: "CollectionReport" */ "./views/reports/accounting/CollectionReportV2.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CollectionReportHourly',
    name: 'collectionReportHourly',
    component: () =>
      import(/* webpackChunkName: "CollectionReport" */ "./views/reports/accounting/CollectionReportV2Hourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RevenueCommissionReport',
    name: 'revenueCommissionReport',
    component: () =>
      import(/* webpackChunkName: "RevenueCommissionReport" */ "./views/reports/accounting/RevenueCommissionReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RevenueCommissionReportHourly',
    name: 'revenueCommissionReportHourly',
    component: () =>
      import(/* webpackChunkName: "RevenueCommissionReport" */ "./views/reports/accounting/RevenueCommissionReportHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OutstandingCollectionReport',
    name: 'outstandingCollectionReport',
    component: () =>
      import(/* webpackChunkName: "OutstandingCollectionReport" */ "./views/reports/operation/OutstandingCollectionReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomTransfer',
    name: 'roomTransfer',
    component: () =>
      import(/* webpackChunkName: "RoomTransfer" */ "./views/reports/operation/ChangeRoomReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaVsNonOtaChannelComparison',
    name: 'OtaVsNonOtaChannelComparison',
    component: () =>
      import(/* webpackChunkName: "OtaVsNonOtaChannelComparisonView" */ "./views/reports/marketing/OtaVsNonOtaChannelComparison.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaVsNonOtaChannelComparisonHourly',
    name: 'OtaVsNonOtaChannelComparisonHourly',
    component: () =>
      import(/* webpackChunkName: "OtaVsNonOtaChannelComparisonView" */ "./views/reports/marketing/OtaVsNonOtaChannelComparisonHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaChannelComparison',
    name: 'OtaChannelComparison',
    component: () =>
      import(/* webpackChunkName: "OtaChannelComparisonView" */ "./views/reports/marketing/OtaChannelComparison.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaChannelComparisonHourly',
    name: 'OtaChannelComparisonHourly',
    component: () =>
      import(/* webpackChunkName: "OtaChannelComparisonView" */ "./views/reports/marketing/OtaChannelComparisonHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaPromotion',
    name: 'OtaPromotion',
    component: () =>
      import(/* webpackChunkName: "OtaPromotionView" */ "./views/reports/marketing/OtaPromotionSettings/OtaPromotion.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },


  {
    path: '/ShiftDetails',
    name: 'shiftDetails',
    component: () =>
      import(/* webpackChunkName: "ShiftDetails" */ "./views/reports/operation/ShiftDetailReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  }
  ,
  {
    path: '/OtaPerformanceByCountry',
    name: 'OtaPerformanceByCountry',
    component: () =>
      import(/* webpackChunkName: "OtaPerformanceByCountryView" */ "./views/reports/marketing/OtaPerformanceByCountry.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtaPerformanceByCountryHourly',
    name: 'OtaPerformanceByCountryHourly',
    component: () =>
      import(/* webpackChunkName: "OtaPerformanceByCountryView" */ "./views/reports/marketing/OtaPerformanceByCountryHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/NonOtaChannelComparison',
    name: 'NonOtaChannelComparison',
    component: () =>
      import(/* webpackChunkName: "NonOtaChannelComparisonView" */ "./views/reports/marketing/NonOtaChannelComparison.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/NonOtaChannelComparisonHourly',
    name: 'NonOtaChannelComparisonHourly',
    component: () =>
      import(/* webpackChunkName: "NonOtaChannelComparisonView" */ "./views/reports/marketing/NonOtaChannelComparisonHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/REVPAR',
    name: 'REVPAR',
    component: () =>
      import(/* webpackChunkName: "REVPARView" */ "./views/reports/revenue/REVPAR.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  }
  ,
  {
    path: '/ShiftKioskReport',
    name: 'shiftKiosk',
    component: () =>
      import(/* webpackChunkName: "ShiftDetails" */ "./views/reports/operation/ShiftKioskReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  }
  ,
  {
    path: '/RevenueAndOccupancyRate',
    name: 'RevenueAndOccupancyRate',
    component: () =>
      import(/* webpackChunkName: "RevenueAndOccupancyRateView" */ "./views/reports/revenue/RevenueAndOccupancyRate.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  }
  //,
  //{
  //  path: '/RevenueAndOccupancyRate',
  //  name: 'RevenueAndOccupancyRate',
  //  component: () =>
  //    import(/* webpackChunkName: "DailySalesAndOccupancy" */ "./views/reports/revenue/DailySalesAndOccupancy.vue"),
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  //}


  ,
  {
    path: '/GuestProfilebyCountryandAge',
    name: 'GuestProfilebyCountryandAge',
    component: () =>
      import(/* webpackChunkName: "GuestProfilebyCountryandAgeView" */ "./views/reports/marketing/GuestProfilebyCountryandAge.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }

  },
  {
    path: '/DepositReport',
    name: 'DepositReport',
    component: () =>
      import(/* webpackChunkName: "InvoiceReport" */ "./views/reports/operation/DepositReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RefundDepositReport',
    name: 'RefundDepositReport',
    component: () =>
      import(/* webpackChunkName: "InvoiceReport" */ "./views/reports/operation/RefundDepositReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/InRoomAmenity',
    name: 'inRoomAmenity',
    component: () =>
      import(/* webpackChunkName: "InRoomAmenity" */ "./views/InRoomAmenity.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },
  {
    path: '/ServiceRequestType',
    name: 'serviceRequestType',
    component: () =>
      import(/* webpackChunkName: "ServiceRequestType" */ "./views/ServiceRequestType.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },
  {
    path: '/MorningCallRequest',
    name: 'morningCallRequest',
    component: () =>
      import(/* webpackChunkName: "MorningCallRequest" */ "./views/MorningCallRequest.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },
  {
    path: '/InRoomAmenityRequest',
    name: 'inRoomAmenityRequest',
    component: () =>
      import(/* webpackChunkName: "InRoomAmenityRequest" */ "./views/InRoomAmenityRequest.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },

  {
    path: '/GstServiceSetting',
    name: 'gstServiceSetting',
    component: () =>
      import(/* webpackChunkName: "GstServiceSettingView" */ "./views/gstService/GstServiceSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PaymentModeSetting',
    name: 'paymentmModeSetting',
    component: () =>
      import(/* webpackChunkName: "PaymentModeSettingView" */ "./views/paymentmode/PaymentModeSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/TransactionCodeSetting',
    name: 'transactionCodeSetting',
    component: () =>
      import(/* webpackChunkName: "TransactionCodeSettingView" */ "./views/ChargableItem/TransactionCodeSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/MaterialSetting/:TransactionCodeId/Upload',
    name: 'materialSetting',
    component: () =>
      import(/* webpackChunkName: "MaterialSettingView" */ "./views/ChargableItem/MaterialSetting.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CMRoomTypeSetting',
    name: 'cMRoomTypeSetting',
    component: () =>
      import(/* webpackChunkName: "CMRoomTypeSettingView" */ "./views/channelManager/roomTypes/CMRoomTypeSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyYearandMonthVariance',
    name: 'OverallPerformancebyYearandMonthVariance',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyYearandMonthVarianceView" */ "./views/reports/revenue/OverallPerformancebyYearandMonthVariance.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OverallPerformancebyYearandMonthVarianceHourly',
    name: 'OverallPerformancebyYearandMonthVarianceHourly',
    component: () =>
      import(/* webpackChunkName: "OverallPerformancebyYearandMonthVarianceView" */ "./views/reports/revenue/OverallPerformancebyYearandMonthVarianceHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  //{
  //  path: '/OtaPromotion',
  //  name: 'OtaPromotion',
  //  component: () =>
  //    import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/marketing/OtapromotionSettings/OtaPromotion.vue"),
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  //},
  {
    path: '/ModeSetting',
    name: 'ModeSetting',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/revenue/ModeSettings/Mode.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomStatusException',
    name: 'RoomStatusException',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/operation/RoomStatusException.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomStatusExceptionHourly',
    name: 'RoomStatusExceptionHourly',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/operation/RoomStatusExceptionHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomAllocationException',
    name: 'RoomAllocationException',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/operation/RoomAllocationException.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CancellationDiscount',
    name: 'CancellationDiscount',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/accounting/CancellationDiscountReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/BookingCancel',
    name: 'BookingCancel',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/accounting/BookingCancelReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CreditLimit',
    name: 'CreditLimit',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/accounting/CreditLimitReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CreditLimitHourly',
    name: 'CreditLimitHourly',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/accounting/CreditLimitReportHourly.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RateDiscrepancy',
    name: 'RateDiscrepancy',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/revenue/RateDiscrepancyReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OtherIncome',
    name: 'OtherIncome',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/reports/accounting/OtherIncomeReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/HousekeeperPerformance',
    name: 'HousekeeperPerformance',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/ischeduler/reports/HousekeeperPerformance.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PastCleaning',
    name: 'PastCleaning',
    component: () =>
      import(/* webpackChunkName: "PastCleaningView" */ "./views/ischeduler/reports/PastCleaningReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/WorkingHours',
    name: 'WorkingHours',
    component: () =>
      import(/* webpackChunkName: "RoomTypeChannelAvailabilityView" */ "./views/ischeduler/reports/WorkingHours.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/ChartOfAccount',
    name: 'ChartOfAccount',
    component: () =>
      import(/* webpackChunkName: "ChartOfAccountView" */ "./views/chartOfAccount/ChartOfAccount.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ChartOfAccountItem/:ChartOfAccountId',
    name: 'ChartOfAccountItem',
    props: true,
    component: () =>
      import(/* webpackChunkName: "ChartOfAccountItemView" */ "./views/chartOfAccount/ChartOfAccountItem.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/Journal',
    name: 'Journal',
    component: () =>
      import(/* webpackChunkName: "JournalView" */ "./views/journal/Journal.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/PNLReport',
    name: 'PNLReport',
    component: () =>
      import(/* webpackChunkName: "ProfitAndLossReportView" */ "./views/accountingReport/ProfitAndLossReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/BSReport',
    name: 'BSReport',
    component: () =>
      import(/* webpackChunkName: "BalanceSheetReportView" */ "./views/accountingReport/BalanceSheetReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/TBReport',
    name: 'TBReport',
    component: () =>
      import(/* webpackChunkName: "TrialBalanceReportView" */ "./views/accountingReport/TrialBalanceReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/JournalItem/:JournalId/Edit',
    name: 'JournalItemEdit',
    props: true,
    component: () =>
      import(/* webpackChunkName: "JournalItemView" */ "./views/journal/JournalItem.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/JournalItem/:JournalId/New',
    name: 'JournalItemNew',
    props: true,
    component: () =>
      import(/* webpackChunkName: "JournalItemView" */ "./views/journal/JournalItem.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/FinanceYear',
    name: 'FinanceYear',
    component: () =>
      import(/* webpackChunkName: "FinanceYearView" */ "./views/financeYear/FinanceYearSetting.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/ChartOfAccountListReport',
    name: 'ChartOfAccountListReport',
    component: () =>
      import(/* webpackChunkName: "ChartOfAccountListReportView" */ "./views/accountingReport/ChartOfAccountListReport.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }

  },
  {
    path: '/PropertySettings',
    name: 'PropertySettings',
    component: () =>
      import(/* webpackChunkName: "PropertySettingsView" */ "./views/bookingEngine/propertyContent/PropertySettings.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/HotDeals',
    name: 'HotDeals',
    component: () =>
      import(/* webpackChunkName: "HotDealView" */ "./views/bookingEngine/hotDeals/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/RoomTypeContent',
    name: 'RoomTypeContent',
    component: () =>
      import(/* webpackChunkName: "RoomTypeContentView" */ "./views/bookingEngine/roomTypeContent/Index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomContent',
    name: 'RoomContent',
    component: () =>
      import(/* webpackChunkName: "RoomContentView" */ "./views/bookingEngine/roomTypeContent/IndexRoomType.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/BookingList',
    name: 'BookingList',
    component: () =>
      import(/* webpackChunkName: "BookingListView" */ "./views/bookingEngine/reservation/BookingList.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/reservation/edit/:RoomId',
    name: 'EditReservation',
    component: () =>
      import(/* webpackChunkName: "EditReservationView" */ "./views/bookingEngine/reservation/EditReservation.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RatePackage',
    name: 'RatePackage',
    component: () =>
      import(/* webpackChunkName: "RatePackageView" */ "./views/bookingEngine/RatePackage/index.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/OTARatePackage',
    name: 'OTARatePackage',
    component: () =>
      import(/* webpackChunkName: "OTARatePackageView" */ "./views/bookingEngine/RatePackage/OTAIndex.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/StopSell',
    name: 'StopSell',
    component: () =>
      import(/* webpackChunkName: "StopSellView" */ "./views/bookingEngine/RatePackage/StopSellOTA.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RateChangeLog',
    name: 'RateChangeLog',
    component: () =>
      import(/* webpackChunkName: "RateChangeLogView" */ "./views/bookingEngine/RatePackage/RateChangeLog.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RateResetLog',
    name: 'RateResetLog',
    component: () =>
      import(/* webpackChunkName: "RateResetLogView" */ "./views/bookingEngine/RatePackage/RateResetLog.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/RoomMapping',
    name: 'RoomMapping',
    component: () =>
      import(/* webpackChunkName: "RoomMappingView" */ "./views/bookingEngine/roomMapping/Mapping.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PropertySU',
    name: 'PropertySU',
    component: () =>
      import(/* webpackChunkName: "PropertySUView" */ "./views/channelManager/suManager/PropertyContent.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/RoomTypeSU',
    name: 'RoomTypeSU',
    component: () =>
      import(/* webpackChunkName: "RoomTypeSUView" */ "./views/channelManager/suManager/RoomType.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/ChannelMapping',
    name: 'ChannelMapping',
    component: () =>
      import(/* webpackChunkName: "RatePlanSUView" */ "./views/channelManager/suManager/ChannelMapping.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false, showBreadCrumb: false }
  },
  {
    path: '/RatePlanSU',
    name: 'RatePlanSU',
    component: () =>
      import(/* webpackChunkName: "RatePlanSUView" */ "./views/channelManager/suManager/RatePlanContent.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/BookingPolicy',
    name: 'BookingPolicy',
    component: () =>
      import(/* webpackChunkName: "BookingPolicyView" */ "./views/bookingEngine/bookingPolicy/BookingPolicy.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/ExtraService',
    name: 'extraService',
    component: () =>
      import(/* webpackChunkName: "ExtraServiceView" */ "./views/bookingEngine/extraServices/Index.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/PaymentSetting',
    name: 'Payment',
    component: () =>
      import(/* webpackChunkName: "PaymentView" */ "./views/bookingEngine/paymentSetting/Index.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/PaymentSettingLog',
    name: 'PaymentSettingLog',
    component: () =>
      import(/* webpackChunkName: "PaymentView" */ "./views/bookingEngine/paymentSetting/PaymentGatewayAuditLog.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  //{
  //  path: '/RoomMapping',
  //  name: 'map',
  //  component: () =>
  //    import(/* webpackChunkName: "MapView" */ "./views/bookingEngine/map/Index.vue"),
  //  props: true,
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  //},

  {
    path: '/PromotionCoupon',
    name: 'promoCodes',
    component: () =>
      import(/* webpackChunkName: "PromoCodeView" */ "./views/bookingEngine/promoCode/Index.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/bookingReport',
    name: 'bookingReport',
    component: () =>
      import(/* webpackChunkName: "BookingReportListView" */ "./views/reports/booking/BookingReportList.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  //{
  //  path: '/banner',
  //  name: 'banner',
  //  component: () =>
  //    import(/* webpackChunkName: "BannerAndBackgroundView" */ "./views/bookingEngine/bannerBackground/Index.vue"),
  //  props: true,
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  //},

  //{
  //  path: '/settings',
  //  name: 'settings',
  //  component: () =>
  //    import(/* webpackChunkName: "SettingsView" */ "./views/bookingEngine/settings/Index.vue"),
  //  props: true,
  //  meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  //},

  {
    path: '/BannerBackground',
    name: 'BannerBackground',
    component: () =>
      import(/* webpackChunkName: "BackgroundAndSettingsView" */ "./views/bookingEngine/settingAndBackground/Index.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/addOnReport',
    name: 'addOnReport',
    component: () =>
      import(/* webpackChunkName: "AddOnReportsView" */ "./views/reports/addons/AddOnReportList.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/activityLog',
    name: 'activityLog',
    component: () =>
      import(/* webpackChunkName: "ActivityLogView" */ "./views/reports/operation/ActivityLog.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/DepositRequired',
    name: 'DepositRequired',
    component: () =>
      import(/* webpackChunkName: "DepositRequiredView" */ "./views/reports/operation/DepositRequiredReport.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/CreateReservation/:InititalStartDate',
    name: 'CreateReservation',
    component: () =>
      import(/* webpackChunkName: "CreateReservationView" */ "./views/bookingEngine/reservation/CreateReservation.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/revenueReport',
    name: 'revenueReport',
    component: () =>
      import(/* webpackChunkName: "RevenueReportView" */ "./views/reports/revenue/RevenueReport.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/AutoCheckOutPostInvoice',
    name: 'autoCheckOutPostInvoice',
    component: () =>
      import(/* webpackChunkName: "RevenueReportView" */ "./views/itFunction/AutoCheckOutPostInvoice.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent }
  },

  {
    path: '/permissionchecker',
    name: 'permissionchecker',
    component: () =>
      import(/* webpackChunkName: "PermissionCheckerView" */ "./views/internalSetting/PermissionsChecker.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },
  {
    path: '/EmailerAccount',
    name: 'emaileraccount',

    component: () =>
      import(/* webpackChunkName: "EmailerAccountView" */ "./views/emailerModule/EmailerAccount.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/EmailerCategory',
    name: 'emailercategory',

    component: () =>
      import(/* webpackChunkName: "EmailerCategoryView" */ "./views/emailerModule/EmailerCategory.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/EmailerSubCategory',
    name: 'emailersubcategory',

    component: () =>
      import(/* webpackChunkName: "EmailerSubCategoryView" */ "./views/emailerModule/EmailerSubCategory.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/EmailerContact',
    name: 'emailercontact',

    component: () =>
      import(/* webpackChunkName: "EmailerContactView" */ "./views/emailerModule/EmailerContact/EmailerContact.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailerTemplate',
    name: 'emailertemplate',

    component: () =>
      import(/* webpackChunkName: "EmailerTemplateView" */ "./views/emailerModule/EmailerTemplate/EmailerTemplateList.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailerTemplateDetail/:EmailerTemplateId/Edit',
    name: 'emailertemplatedetailEdit',
    props: true,
    component: () =>
      import(/* webpackChunkName: "EmailerTemplateDetailView" */ "./views/emailerModule/EmailerTemplate/EmailerTemplateDetail.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/EmailerTemplateDetail/:EmailerTemplateId/New',
    name: 'emailertemplatedetailNew',
    props: true,
    component: () =>
      import(/* webpackChunkName: "EmailerTemplateDetailView" */ "./views/emailerModule/EmailerTemplate/EmailerTemplateDetail.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailJob',
    name: 'emailerjob',

    component: () =>
      import(/* webpackChunkName: "EmailerJobListView" */ "./views/emailerModule/EmailerJob/EmailerJobList.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },


  {
    path: '/EmailAdhoc',
    name: 'emailerAdhoc',

    component: () =>
      import(/* webpackChunkName: "EmailerJobListView" */ "./views/emailerModule/EmailerAdhocEmail.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailJobLog',
    name: 'emailJobLog',

    component: () =>
      import(/* webpackChunkName: "EmailerJobLogListView" */ "./views/emailerModule/EmailerJobLog/EmailerJobLogList.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },


  {
    path: '/EmailerJobLogDetail/:EmailerJobId',
    name: 'emailerJobLogDetail',
    component: () =>
      import(/* webpackChunkName: "EmailerJobLogDetailsView" */ "./views/emailerModule/EmailerJobLog/EmailerJobLogDetail.vue"),
    props: true,
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },

  {
    path: '/EmailerLimitControl',
    name: 'emailerLimitControl',
    component: () =>
      import(/* webpackChunkName: "EmailerLimitControlMainView" */ "./views/emailerModule/EmailerLimitControl/EmailerLimitControlMain.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: isRequiredPermission }
  },
  {
    path: '/LanguageSetup',
    name: 'LanguageSetup',
    component: () =>
      import(/* webpackChunkName: "LanguageSetupView" */ "./views/translationLanguage/LanguageSetup.vue"),
    meta: { requiresAuth: isRequiredAuth, layout: MainComponent, requiresPermission: false }
  },



];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

 
  if ((to.name === from.name && from.name !== 'reservationDetails') || (from.name === 'reservationDetails' && to.query == from.query)) {
    next(false);
    return;
  }

  if (to.name === null && to.path === '/website') {
    store.dispatch('redirectToBEWebsite');
  }



  if (to.matched.some(record => record.meta.requiresAuth)) {

    // console.log('route requires auth');

    if (isAuthenticated()) {

      // console.log('authenticated');

      fetchUserData().then(() => {

        // console.log('fetching user data completed');

        if (to.meta.requiresPermission) {
          if (!store.getters['permission/canUserAccessUrl'](to.matched[0].path)) {
            // console.log('404 err');
            next({ name: "pageNotFound" });
          } else {
            // console.log('url checks passed');
            store.dispatch('permission/setUpBreadcrumbs', { url: to.matched[0].path, params: to.params });
            next();
          }
        } else if ((to.meta.redirectIfCanAccessUrl != undefined && to.meta.redirectIfCanAccessUrl.length > 0) && store.getters['permission/canUserAccessUrl'](to.meta.redirectIfCanAccessUrl)) {

          // console.log('redirect meta detected');
          next(to.meta.redirectIfCanAccessUrl);
        } else {
          // console.log('permissions not required');
          // console.log('proceeddddd');
          // console.log(to, 'to');
          //store.dispatch('permission/setUpBreadcrumbs', { url: to.matched[0].path, params: to.params });
          next();
        }
      });
    } else {
      // console.log('redirect to login');
      next({ name: "login" });
    }
  } else {

    // console.log('dont require auth');

    if (isAuthenticated() && to.meta.requiresGuest) {
      // console.log('visited required guest route while autheticated');
      next('/');
    } else {
      // console.log('proceed');
      // console.log(to, 'to');
      store.dispatch('permission/setUpBreadcrumbs', { url: to.matched[0].path, params: to.params });
      next();
    }
  }

});

function fetchUserData() {
  // console.log('fetching user details');
  return store.dispatch('GetUserDetails').then(() => {
    // console.log('fetching user datails completed');
    // console.log('fetching user permissions');
    return store.dispatch('permission/getUserPermissions');
  });
}

function isAuthenticated() {
  let accessDetails = JSON.parse(localStorage.getItem('access_details'));
  return !accessDetails ? false : true;
}

export default router



// WEBPACK FOOTER //
// ./src/router.js